let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("87j6O")).then(() => parcelRequire('kAaAo'));